export default "__VITE_ASSET__Bif6gFDv__"